import usePersistedState from 'src/hooks/globalState/usePersistedState';
import StorageKeys from 'src/lib/storage/storageKeys';
import { resolveTenancy } from '../../tenancy';
import { getDefaultDebugSettingsState } from './utils';
export default function useDebugSettingsStorage() {
    const [state, setState] = usePersistedState(StorageKeys.debugSettings);
    const defaults = getDefaultDebugSettingsState();
    const merged = state
        ? { ...defaults, ...state, tenancy: resolveTenancy(state.tenancy, defaults.tenancy) }
        : defaults;
    return [merged, setState];
}
